// DeferredConfirmation — the third outcome of an action, next to
// "succeeded" and "failed": the server declined to do it silently and
// handed back something the operator has to answer first.
//
// SM-520 is the case it was written for. Publishing an event that no
// trader would be able to see is refused with a sentence explaining
// why; the panel turns that into a "Publish anyway?" dialog. Reported
// as an ordinary rejection it would also raise a red failure toast and
// an inline error, telling the operator the action broke while a dialog
// asks them to confirm it — three contradictory signals for one click.
//
// Throw this from a mutationFn instead. The toast handler in main.tsx
// stays quiet for it, and hosts that render inline error text skip it
// the same way; the dialog the thrower opened is the whole feedback.
export class DeferredConfirmation extends Error {
  readonly reason: string;

  constructor(reason: string) {
    super(reason);
    this.name = "DeferredConfirmation";
    this.reason = reason;
  }
}

export function isDeferredConfirmation(err: unknown): err is DeferredConfirmation {
  return err instanceof DeferredConfirmation;
}
